import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=3110547e&scoped=true"
import script from "./CouponList.vue?vue&type=script&lang=js"
export * from "./CouponList.vue?vue&type=script&lang=js"
import style0 from "./CouponList.vue?vue&type=style&index=0&id=3110547e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3110547e",
  null
  
)

export default component.exports